import { getApp, getApps, initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore, memoryLocalCache, persistentLocalCache, persistentMultipleTabManager, persistentSingleTabManager } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { isChromiumBrowser, shouldUseEphemeralLocalFirebase, shouldUseSingleTabFirestore } from "../utils/pwaDisplay";

// 1. Construcción del objeto de configuración usando variables de entorno
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// 2. Validación de Seguridad (Diagnóstico)
// Esto imprimirá en tu consola si React no está leyendo el archivo .env
if (!firebaseConfig.apiKey) {
  console.error("🔥 ERROR CRÍTICO DE CONFIGURACIÓN 🔥");
  console.error("React no está leyendo la API KEY del archivo .env");
  console.error("Asegúrate de haber reiniciado la terminal con 'npm start' después de crear el archivo .env");
} else {
  console.log("✅ Firebase Config cargada correctamente. Project ID:", firebaseConfig.projectId);
}

// 3. Inicializar Firebase
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// 4. Inicializar servicios
// Local: memoria (HMR / otra pestaña no traba IndexedDB).
// Móvil / PWA: una sola pestaña. Chrome de escritorio no comparte ese IndexedDB:
// si lo abre, el primer getDocs (team_members) se queda esperando el candado.
// Chromium: long-polling forzado. Auto-detect sigue probando HTTP/3 y el perfil
// staff muere a los 8s (Safari no usa ese canal).
const chromium = isChromiumBrowser();
const memoryCache = shouldUseEphemeralLocalFirebase() || (chromium && !shouldUseSingleTabFirestore());
let db;
try {
  db = initializeFirestore(app, {
    localCache: memoryCache
      ? memoryLocalCache()
      : persistentLocalCache({
          tabManager: shouldUseSingleTabFirestore()
            ? persistentSingleTabManager()
            : persistentMultipleTabManager()
        }),
    ...(chromium
      ? { experimentalForceLongPolling: true }
      : { experimentalAutoDetectLongPolling: true }),
  });
} catch (err) {
  console.warn('[FIRESTORE] Init con transporte propio falló, usando default:', err?.message || err);
  db = getFirestore(app);
}

const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch((e) => {
  console.warn('[AUTH] No se pudo fijar persistencia local:', e?.message || e);
});
const storage = getStorage(app);
/** Staff Nexus — solo cuentas @plexarian.com */
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ hd: 'plexarian.com', prompt: 'select_account' });

/** Portal cliente (licencias, localhost) y soporte.plexarian.com — sin restricción hd */
const supportGoogleProvider = new GoogleAuthProvider();
supportGoogleProvider.setCustomParameters({ prompt: 'select_account' });

// 5. Exportar servicios
export { db, auth, storage, googleProvider, supportGoogleProvider, firebaseConfig };